import { render, staticRenderFns } from "./IncomingCalls.vue?vue&type=template&id=5130d2c0&"
import script from "./IncomingCalls.vue?vue&type=script&lang=js&"
export * from "./IncomingCalls.vue?vue&type=script&lang=js&"
import style0 from "./IncomingCalls.vue?vue&type=style&index=0&id=5130d2c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports